import { render, staticRenderFns } from "./second_videoListForm.vue?vue&type=template&id=3b6c180c&scoped=true&"
import script from "./second_videoListForm.vue?vue&type=script&lang=js&"
export * from "./second_videoListForm.vue?vue&type=script&lang=js&"
import style0 from "./second_videoListForm.vue?vue&type=style&index=0&id=3b6c180c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c180c",
  null
  
)

export default component.exports